import TechnicalValidationRequirements from 'views/components/Validation/TechnicalValidationRequirements/TechnicalValidationRequirements';

export default TechnicalValidationRequirements;
